export default "__VITE_ASSET__WQwFFFrs__"